import styled from "styled-components"
import {label3} from "@irati/ui/src/Labels/css/labels"
import padding from "@irati/ui/src/global/padding"

const ColHeader = styled.div`
  ${label3}
  padding-bottom: ${padding.tiny};
`

export default ColHeader
